"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuideInfoWindowSport = void 0;
var React = require("react");
exports.DbGuideInfoWindowSport = function (props) { return (React.createElement("div", null,
    React.createElement("img", { width: 40, src: props.logo, alt: props.name }))); };
